module.exports = __webpack_public_path__ + "img/Logo-27.7a135066.svg";